import { GridRowId } from '@mui/x-data-grid';

import { _request,APIBaseResponse, APIMethod } from '..';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const CLAIMS_PATH_PREFIX = 'claims';

type APIClaimGetParams = {
    tenantId: string;
    id: string;
};

export type APIClaimGetResponse = APIBaseResponse<{
    tenantId: string;
    id: string;
    name: string;
    claimDataTypeId: string;
    claimDataTypeName: string;
}>;

export type Claim = {
    tenantId: string;
    id: string;
    name: string;
    claimDataTypeId: string;
    claimDataTypeName: string;
}

export const APIClaimGet: APIMethod<APIClaimGetParams, APIClaimGetResponse> = (params: APIClaimGetParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${CLAIMS_PATH_PREFIX}/${params.id}`)
);

type APIClaimsGetParams = RequestParamsBase & {
    tenantId: string;
};

type APIClaimsGetResponse = APIBaseResponse<Array<Claim>>;

export const APIClaimsGetList: APIMethod<APIClaimsGetParams, APIClaimsGetResponse> = (params: APIClaimsGetParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${CLAIMS_PATH_PREFIX}`, undefined, params.signal));

export type APIClaimPostParams = {
    name: string;
    tenantId: string;
    claimDataTypeId: string;
};

export type APIClaimPostResponse = APIBaseResponse<{ claimId: string }>;

export const APIClaimPost: APIMethod<APIClaimPostParams, APIClaimPostResponse> = (params) => (
    _request<APIClaimPostResponse>(
        'POST',
        `${TENANTS_PATH_PREFIX}/${params.tenantId}/${CLAIMS_PATH_PREFIX}`,
        params)
);

export type APIClaimPutParams = {
    name: string;
    id: GridRowId;
    tenantId: string;
};

export const APIClaimPut: APIMethod<APIClaimPutParams, APIBaseResponse> = (params) => (
    _request<APIBaseResponse>('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${CLAIMS_PATH_PREFIX}/${params.id}`, {
        id: params.id,
        name: params.name,
        tenantId: params.tenantId,
    })
);

type APIClaimDeleteParams = {
    id: string;
    tenantId: string;
};

type APIClaimDeleteResponse = APIBaseResponse<''>;

export const APIClaimDelete: APIMethod<APIClaimDeleteParams, APIClaimDeleteResponse> = (params: APIClaimDeleteParams) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${CLAIMS_PATH_PREFIX}/${params.id}`));
